<template>
  <div
    class="w-fit rounded-full"
    :class="{
      'free-loader-shadow bg-background-neutral-secondary p-2.5': !withoutBase,
    }"
    :style="{ width: loaderSize.container, height: loaderSize.container }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="loader-color animate-spin"
      :width="loaderSize.svg"
      :height="loaderSize.svg"
      viewBox="0 0 52 52"
      fill="none"
    >
      <!-- prettier-ignore -->
      <path stroke="currentColor" stroke-linecap="round" stroke-width="4" d="M26 50c13.255 0 24-10.745 24-24S39.255 2 26 2 2 12.745 2 26"/>
      <defs>
        <radialGradient
          id="a"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(99.13 1.922 24.078) scale(24.308)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#72BF44" stop-opacity="0" />
          <stop offset=".224" stop-color="#5DB871" stop-opacity=".04" />
          <stop offset=".802" stop-color="#5DB871" stop-opacity=".81" />
          <stop offset="1" stop-color="#5DB871" />
        </radialGradient>
      </defs>
    </svg>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  enum LoaderSize {
    XS = 'xs',
    MD = 'md',
    LG = 'lg',
  }

  const sizes = {
    [LoaderSize.LG]: {
      container: 160,
      svg: 120,
    },
    [LoaderSize.MD]: {
      container: 72,
      svg: 52,
    },
    [LoaderSize.XS]: {
      container: 32,
      svg: 23,
    },
  };

  const props = withDefaults(
    defineProps<{
      size?: LoaderSize;
      withoutBase?: boolean;
    }>(),
    {
      size: LoaderSize.MD,
    },
  );

  const loaderSize = computed(() => sizes[props.size]);
</script>

<style scoped>
  .free-loader-shadow {
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
  }

  .loader-color {
    color: var(--free-loader-color, #4ebc73);
  }
</style>
